import React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

export const Label = ({ children, htmlFor, required, ...props }) => {
  return (
    <StyledLabel htmlFor={htmlFor} data-required={required} {...props}>
      {children}
    </StyledLabel>
  )
}

Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string.isRequired,
}

const StyledLabel = styled.label`
  color: ${props => props.theme.color.n100};
  display: block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  padding: 4px 0 0;
  margin: 12px 0 0;

  :after {
    color: ${props => props.theme.color.r500};
    content: ' *';
    display: ${props => (props['data-required'] ? 'inline' : 'none')};
  }
`
